import { render, staticRenderFns } from "./CommentView.vue?vue&type=template&id=32983df8&scoped=true"
import script from "./CommentView.vue?vue&type=script&lang=ts"
export * from "./CommentView.vue?vue&type=script&lang=ts"
import style0 from "./CommentView.vue?vue&type=style&index=0&id=32983df8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32983df8",
  null
  
)

export default component.exports